module.exports = __webpack_public_path__ + "static/media/6732.0e55de3f.jpg";